export const SOFTLINE_FEATURE_CHECKLISTEN = 'softapps/allgemein/checklisten';
export const SOFTLINE_FEATURE_CHECKPUNKTE = 'softapps/allgemein/checkpunkte';

export const SOFTLINE_PERMISSION_CHECKLISTE = 'AUFGABEN_CHECKLISTE';
